/** @file A component rendering a simple chevron with label for conventional accordion style UI. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as icons from '@codegrade/icons';
import { Icon } from '@/components/Icon';
import * as utils from '@/utils';
/**
 * Collapse Header - A visual and interactive header for a collapsible content section.
 *
 * This component renders a chevron icon and a label (provided via the default slot).
 * It is designed to be used as the header for a collapse component, providing
 * a way for users to expand and collapse associated content.
 *
 * How the component looks when the parent Collapse is collapsed:
 * `> (your label here)`.
 *
 * How the component looks when the parent Collapse is not collapsed:
 * `v (your label here)`.
 */
export const CollapseHeader = tsx
    .componentFactoryOf()
    .create({
    name: 'collapse-header',
    props: {
        /** Indicates whether the parent Collapse component's content is currently collapsed. */
        collapsed: p.ofType().required,
        /** Applies different typography preset and styling to the header. */
        headerStyle: p
            .ofType()
            .default('title-small'),
    },
    /** @returns Nodes of this component. */
    render() {
        return (<div class={['flex items-center gap-1', this.headerStyle]}>
                    <Icon icon={icons.ChevronRight} class={[
                'transition duration-200',
                {
                    'rotate-90': this.collapsed === false,
                },
            ]}/>
                    {utils.renderSlot(this, 'default', {})}
                </div>);
    },
});
